/**
 * Format a sail/departure date for display without UTC off-by-one.
 * Date-only strings (YYYY-MM-DD) are treated as local calendar dates.
 */
export function parseSailDate(value) {
  if (value == null || value === "") return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  const s = String(value).trim();
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) {
    return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  }
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatSailDate(value, options = { year: "numeric", month: "long", day: "numeric" }) {
  const d = parseSailDate(value);
  if (!d) return "TBD";
  return d.toLocaleDateString(undefined, options);
}

export function toDateString(value) {
  const d = parseSailDate(value);
  if (!d) return "";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
